const mobileSpecializedAreaCodes = [
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '21',
  '22',
  '24',
  '27',
  '31',
  '34',
  '37',
  '41',
  '42',
  '43',
  '44',
  '47',
  '48',
  '51',
  '54',
  '61',
  '62',
  '65',
  '71',
  '73',
  '75',
  '81',
  '85',
]

const personalMobileAndLandlineAreaCodes = [
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '21',
  '22',
  '24',
  '27',
  '28',
  '31',
  '32',
  '33',
  '34',
  '35',
  '37',
  '38',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '51',
  '53',
  '54',
  '55',
  '61',
  '62',
  '64',
  '63',
  '65',
  '66',
  '69',
  '67',
  '68',
  '69',
  '71',
  '73',
  '74',
  '75',
  '77',
  '79',
  '81',
  '87',
  '82',
  '83',
  '84',
  '85',
  '88',
  '86',
  '89',
  '91',
  '93',
  '94',
  '92',
  '97',
  '95',
  '96',
  '98',
  '99',
]

const LANDLINE_PHONE_LENGTH = 10
const MOBILE_PHONE_LENGTH = 11
const MOBILE_SPECIALIZED_STARTING_NUMBER = '7'

export function phoneValidation(phone: string) {
  phone = phone.replace(/\D/g, '')

  const validPhoneLengths = [LANDLINE_PHONE_LENGTH, MOBILE_PHONE_LENGTH]
  if (!validPhoneLengths.includes(phone.length)) {
    return { isValid: false, message: 'Telefone inválido.' }
  }

  const hasPersonalMobileInitialDigit = checkPersonalMobileInitialDigit(
    phone[2]
  )
  if (phone.length === MOBILE_PHONE_LENGTH || hasPersonalMobileInitialDigit) {
    return verifyPersonalMobilePhone(phone)
  }

  return phone[2] === MOBILE_SPECIALIZED_STARTING_NUMBER
    ? verifySpecializedMobilePhone(phone)
    : verifyLandlinePhone(phone)
}

function verifyLandlinePhone(phone: string) {
  const ddd = phone.substring(0, 2)

  const validInitialDigit = checkLandlineInitialDigit(phone[2])
  const validAreaCode = personalMobileAndLandlineAreaCodes.includes(ddd)

  if (!validInitialDigit || !validAreaCode) {
    return { isValid: false, message: 'Telefone inválido.' }
  }

  return { isValid: true }
}

function checkLandlineInitialDigit(digit: string) {
  return /^[2-5]$/.test(digit)
}

function verifyPersonalMobilePhone(phone: string) {
  const ddd = phone.substring(0, 2)
  const validInitialDigit = checkPersonalMobileInitialDigit(phone[2])

  if (phone.length !== MOBILE_PHONE_LENGTH || !validInitialDigit) {
    return {
      isValid: false,
      message:
        'Telefone inválido, verifique se o número do telefone segue o formato (XX) 9XXXX-XXXX.',
    }
  }

  if (!personalMobileAndLandlineAreaCodes.includes(ddd)) {
    return { isValid: false, message: 'Telefone inválido.' }
  }

  return { isValid: true }
}

function checkPersonalMobileInitialDigit(digit: string) {
  return /^[9]$/.test(digit)
}

function verifySpecializedMobilePhone(phone: string) {
  const ddd = phone.substring(0, 2)
  const initialDigits = phone.substring(2, 4)

  const validInitialDigits = checkMobileSpecializedInitialDigits(initialDigits)
  const validAreaCode = mobileSpecializedAreaCodes.includes(ddd)

  if (!validInitialDigits || !validAreaCode) {
    return { isValid: false, message: 'Telefone inválido.' }
  }

  return { isValid: true }
}

function checkMobileSpecializedInitialDigits(digits: string) {
  return /^7[7-90]$/.test(digits)
}
